import { Button, FlashbarProps, Form, FormField, Input, Multiselect, SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from "@cloudscape-design/components/header";
import React, { useEffect, useRef, useState } from 'react';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';

interface ModuleOption {
    value: string;
    label: string;
    description: string;
    type: string;
    iconSvg: React.ReactNode;
}
export const SystemSecurityAPIKeysAddPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

    const { navigate } = useRouter();
    const { parameters, menu, data, idAirport } = useGlobalState();
    const [apikey, setApiKey] = useState<any>({ idApiKey: 0, description: "", jsonRoutings: [] });

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            navigate('system/security/apikeys')
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);

    const optionsModule: ModuleOption[] = [
        { value: '/routing/api/sicns/publish/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\Ingreso de hora de despliegue de vuelo', description: "\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\/routing/api/sicns/publish/", type: "SICNS", iconSvg: <BadgeCustom color='lime'>SICNS</BadgeCustom> },
        { value: '/routing/api/sicns/report/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\Reporte de hora de despliegue de vuelo', description: "\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\/routing/api/sicns/report/", type: "SICNS", iconSvg: <BadgeCustom color='lime'>SICNS</BadgeCustom> },
        { value: '/routing/api/rms/publish/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0Endpoint para ingreso de información de vuelos', description: "\u00a0\u00a0\u00a0\u00a0\u00a0/routing/api/rms/publish/", type: "RMS", iconSvg: <BadgeCustom color='purple'>RMS</BadgeCustom> },
        { value: '/routing/api/json/flights/', label: '\u00a0\u00a0\u00a0\u00a0\u00a0Listado de vuelos', description: "\u00a0\u00a0\u00a0\u00a0\u00a0/routing/api/json/flights/", type: "JSON", iconSvg: <BadgeCustom color='blue'>JSON</BadgeCustom> },
    ]

    const handleUpdateApiKey = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/system/security/apikeys/update',
                },
                body: JSON.stringify(apikey),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {
                addNotification(dataWeb.status, "success", setData);
                window.location.hash = "#system/security/apikeys";
            } else {
                addNotification(dataWeb.status, "error", setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }

    const getSelectedOptions = (ids: string[], source: ModuleOption[]) =>
        source.filter((s) => ids.includes(s.value));

    const selectedOptions = getSelectedOptions(apikey?.jsonRoutings || [], optionsModule)
    // 3. Handle change: extract only the values to save to state
    const handleRoutingChange = (newSelectedOptions: readonly ModuleOption[]) => {
        const newIds = newSelectedOptions.map(o => o.value);
        setApiKey({
            ...apikey!,
            jsonRoutings: newIds
        });
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Button variant="link" onClick={() => navigate('system/security/apikeys')}

                    >Volver</Button>}>Generar API Key</Header>
                    <Form actions={<Button variant="primary"
                        onClick={() => handleUpdateApiKey()}
                        disabled={getSelectedOptions(apikey?.jsonRoutings || [], optionsModule).length == 0 || apikey?.description.length == 0}
                    >Generar</Button>}>
                        <SpaceBetween size="m" direction='vertical'>

                            <div style={{ width: 400 }}>
                                <FormField label="Descripción">
                                    <Input value={apikey.description} onChange={e => {
                                        setApiKey({ ...apikey, description: e.detail.value });
                                    }} />
                                </FormField>
                            </div>
                            <div style={{ maxWidth: 600 }}>
                                <FormField label="Rutas habilitadas">
                                    <Multiselect
                                        options={optionsModule}
                                        // Cloudscape needs the full objects that match the items in optionsModule
                                        selectedOptions={getSelectedOptions(apikey?.jsonRoutings || [], optionsModule)}
                                        onChange={({ detail }) => handleRoutingChange(detail.selectedOptions as ModuleOption[])}
                                        placeholder={selectedOptions.length == 0 ? "Seleccionar rutas" : `${selectedOptions.length}/${optionsModule.length} rutas seleccionadas`}
                                    />
                                </FormField>
                            </div>
                        </SpaceBetween>
                    </Form>

                </SpaceBetween>
            }
        />
    )
};
